/**
 * Crea tu combo — configurador de piercings sobre oreja (Apodemia)
 * Zonas (acordeones) con swatches de pendientes (siluetados PNG). La selección
 * de cada zona superpone su siluetado en la foto de la oreja (centrado en el
 * punto de la zona). Contador + total + seQura; "Añadir al carrito" añade todas
 * las selecciones (cart:updated → sidecart, patrón del tema).
 */
(function () {
  'use strict';

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    n = n.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return n + ' €';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
        );
      });
  }

  function init(root) {
    var dataEl = root.querySelector('[data-ear-products]');
    if (!dataEl) return;
    var products = [];
    try { products = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var zones = Array.prototype.slice.call(root.querySelectorAll('[data-ear-zone]'));
    var selection = {}; // zoneIndex -> product

    // ----- Pinta los swatches de cada zona ---------------------------------
    zones.forEach(function (zone, zi) {
      var wrap = zone.querySelector('[data-ear-swatches]');
      if (!wrap) return;
      // Productos ocultos en esta zona (ajuste "Ocultar productos" del bloque).
      var hideSet = {};
      (zone.getAttribute('data-ear-hide') || '').split(',').forEach(function (id) {
        id = id.trim();
        if (id) hideSet[id] = true;
      });
      products.forEach(function (p) {
        if (hideSet[String(p.id)]) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'apodemia-ear__swatch';
        b.setAttribute('data-ear-pick', String(p.id));
        b.setAttribute('title', p.title);
        b.setAttribute('aria-label', p.title);
        b.innerHTML = '<img src="' + esc(p.thumb) + '" alt="" loading="lazy">' +
          '<span class="apodemia-ear__swatch-price">+' + money(p.price) + '</span>';
        wrap.appendChild(b);
      });
    });

    // ----- Acordeones (y puntos de la oreja) --------------------------------
    function openZone(zi, exclusive) {
      zones.forEach(function (zone, i) {
        var body = zone.querySelector('[data-ear-zone-body]');
        var head = zone.querySelector('[data-ear-zone-toggle]');
        var open = i === zi ? true : (exclusive ? false : !body.hidden);
        if (i === zi || exclusive) {
          body.hidden = !open;
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      });
      var dot = root.querySelector('[data-ear-dot="' + zi + '"]');
      root.querySelectorAll('[data-ear-dot]').forEach(function (d) { d.classList.remove('is-active'); });
      if (dot) dot.classList.add('is-active');
    }

    zones.forEach(function (zone, zi) {
      var head = zone.querySelector('[data-ear-zone-toggle]');
      var body = zone.querySelector('[data-ear-zone-body]');
      head.addEventListener('click', function () {
        var willOpen = body.hidden;
        body.hidden = !willOpen;
        head.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
    root.querySelectorAll('[data-ear-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var zi = parseInt(dot.getAttribute('data-ear-dot'), 10);
        openZone(zi, true);
        var zone = zones[zi];
        if (zone && zone.scrollIntoView) zone.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });

    // ----- Resaltado cruzado punto <-> zona (hover) -------------------------
    function setHover(zi, on) {
      var dot = root.querySelector('[data-ear-dot="' + zi + '"]');
      var zone = zones[zi];
      if (dot) dot.classList.toggle('is-hover', on);
      if (zone) zone.classList.toggle('is-hover', on);
    }
    zones.forEach(function (zone, zi) {
      var head = zone.querySelector('[data-ear-zone-toggle]');
      if (head) {
        head.addEventListener('mouseenter', function () { setHover(zi, true); });
        head.addEventListener('mouseleave', function () { setHover(zi, false); });
      }
    });
    root.querySelectorAll('[data-ear-dot]').forEach(function (dot) {
      var zi = parseInt(dot.getAttribute('data-ear-dot'), 10);
      dot.addEventListener('mouseenter', function () { setHover(zi, true); });
      dot.addEventListener('mouseleave', function () { setHover(zi, false); });
    });

    // ----- Selección ---------------------------------------------------------
    var totalEl = root.querySelector('[data-ear-total]');
    var instEl = root.querySelector('[data-ear-installment]');
    var addBtn = root.querySelector('[data-ear-add]');
    var summaryEl = root.querySelector('[data-ear-summary]');
    var countEl = root.querySelector('[data-ear-count]');
    var sumEl = root.querySelector('[data-ear-sum]');
    var hintEl = root.querySelector('[data-ear-hint]');
    var resetEl = root.querySelector('[data-ear-reset]');
    var months = addBtn ? (parseInt(addBtn.getAttribute('data-months'), 10) || 3) : 3;

    function refresh() {
      var picks = Object.keys(selection).map(function (k) { return selection[k]; });
      var total = picks.reduce(function (a, p) { return a + p.price; }, 0);
      if (totalEl) totalEl.textContent = money(total);
      if (instEl) instEl.textContent = money(Math.floor(total / months));
      if (addBtn) addBtn.disabled = picks.length === 0;
      if (hintEl) hintEl.hidden = picks.length > 0;
      if (resetEl) resetEl.hidden = picks.length === 0;
      if (summaryEl) {
        summaryEl.hidden = picks.length === 0;
        if (countEl) countEl.textContent = picks.length + ' ' + (picks.length === 1 ? (window.__earT && window.__earT.one || 'Pendiente') : (window.__earT && window.__earT.many || 'Pendientes'));
        if (sumEl) sumEl.textContent = money(total);
      }
    }

    zones.forEach(function (zone, zi) {
      var overlay = root.querySelector('[data-ear-overlay="' + zi + '"]');
      var picked = zone.querySelector('[data-ear-picked]');
      zone.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-ear-pick]');
        if (!btn) return;
        // marca visual
        zone.querySelectorAll('[data-ear-pick]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var id = btn.getAttribute('data-ear-pick');
        if (!id) {
          delete selection[zi];
          if (overlay) { overlay.hidden = true; overlay.removeAttribute('src'); overlay.classList.remove('is-colgante'); }
          if (picked) picked.hidden = true;
        } else {
          var p = products.filter(function (x) { return String(x.id) === id; })[0];
          if (!p) return;
          selection[zi] = p;
          if (overlay) { overlay.src = p.img; overlay.hidden = false; overlay.classList.toggle('is-colgante', !!p.colgante); }
          if (picked) {
            picked.textContent = p.title + ' · +' + money(p.price);
            picked.hidden = false;
          }
        }
        var dot = root.querySelector('[data-ear-dot="' + zi + '"]');
        if (dot) dot.classList.toggle('is-filled', !!selection[zi]);
        refresh();
      });
    });

    // ----- Empezar de nuevo (vaciar todas las selecciones) -------------------
    function resetAll() {
      zones.forEach(function (zone, zi) {
        zone.querySelectorAll('[data-ear-pick]').forEach(function (b) { b.classList.remove('is-selected'); });
        var none = zone.querySelector('.apodemia-ear__swatch--none');
        if (none) none.classList.add('is-selected');
        var overlay = root.querySelector('[data-ear-overlay="' + zi + '"]');
        if (overlay) { overlay.hidden = true; overlay.removeAttribute('src'); overlay.classList.remove('is-colgante'); }
        var picked = zone.querySelector('[data-ear-picked]');
        if (picked) picked.hidden = true;
        var dot = root.querySelector('[data-ear-dot="' + zi + '"]');
        if (dot) dot.classList.remove('is-filled');
        delete selection[zi];
      });
      refresh();
    }
    if (resetEl) resetEl.addEventListener('click', resetAll);

    // ----- Añadir al carrito -------------------------------------------------
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var picks = Object.keys(selection).map(function (k) { return selection[k]; });
        if (!picks.length || addBtn.disabled) return;
        addBtn.disabled = true;
        addToCart(picks.map(function (p) { return { id: p.variant, quantity: 1 }; }))
          .catch(function () {})
          .finally(function () { addBtn.disabled = false; });
      });
    }

    refresh();
  }

  function boot() {
    document.querySelectorAll('[data-ear-builder]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ear-builder]');
    if (root) init(root);
  });
})();
